var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocument(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_5234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.4286 4.00001H12.5714V0.571439C12.5714 0.255837 12.3156 0 12 0H0.571439C0.255837 0 0 0.255837 0 0.571439V13.7143C0 14.9767 1.02335 16 2.28572 16H13.7143C14.9767 16 16 14.9767 16 13.7143V4.57141C16 4.25585 15.7442 4.00001 15.4286 4.00001ZM2.28572 14.8571C1.65455 14.8571 1.14288 14.3454 1.14288 13.7143V1.14285H11.4286V13.7143C11.43 13.852 11.4439 13.9894 11.4703 14.1246C11.476 14.1571 11.4823 14.1892 11.4897 14.2211C11.518 14.3506 11.5573 14.4773 11.6074 14.6C11.6074 14.6057 11.6132 14.6108 11.6154 14.616C11.6506 14.6987 11.6907 14.7792 11.7354 14.8571H2.28572ZM14.8571 13.7143C14.8571 14.3454 14.3454 14.8571 13.7143 14.8571C13.0831 14.8571 12.5714 14.3454 12.5714 13.7143V5.14285H14.8572V13.7143H14.8571Z",
    fill: "#182B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.99995 2.85718H4.57138C4.25578 2.85718 3.99994 3.11301 3.99994 3.42862C3.99994 3.74422 4.25578 4.00006 4.57138 4.00006H7.99995C8.31555 4.00006 8.57139 3.74422 8.57139 3.42862C8.57139 3.11301 8.31555 2.85718 7.99995 2.85718Z",
    fill: "#182B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71416 5.71436H2.85702C2.54142 5.71436 2.28558 5.97019 2.28558 6.28579C2.28558 6.6014 2.54142 6.85723 2.85702 6.85723H9.71416C10.0298 6.85723 10.2856 6.6014 10.2856 6.28579C10.2856 5.97019 10.0298 5.71436 9.71416 5.71436Z",
    fill: "#182B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71416 8H2.85702C2.54142 8 2.28558 8.25584 2.28558 8.57145C2.28558 8.88705 2.54142 9.14289 2.85702 9.14289H9.71416C10.0298 9.14289 10.2856 8.88705 10.2856 8.57145C10.2856 8.25584 10.0298 8 9.71416 8Z",
    fill: "#182B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71416 10.2858H2.85702C2.54142 10.2858 2.28558 10.5416 2.28558 10.8572C2.28558 11.1728 2.54142 11.4286 2.85702 11.4286H9.71416C10.0298 11.4286 10.2856 11.1728 10.2856 10.8572C10.2856 10.5416 10.0298 10.2858 9.71416 10.2858Z",
    fill: "#182B1C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.71416 12.5714H2.85702C2.54142 12.5714 2.28558 12.8272 2.28558 13.1429C2.28558 13.4585 2.54145 13.7143 2.85702 13.7143H9.71416C10.0298 13.7143 10.2856 13.4584 10.2856 13.1428C10.2856 12.8272 10.0298 12.5714 9.71416 12.5714Z",
    fill: "#182B1C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_5234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocument);
export default __webpack_public_path__ + "static/media/Document.c29b9441.svg";
export { ForwardRef as ReactComponent };